<script>
  export let shown = false;

  import { createEventDispatcher } from "svelte";
  import { fade, fly } from "svelte/transition";
  const dispatch = createEventDispatcher();

  import Router from "svelte-spa-router";
  import Power from "./content/power.svelte";
  import SelfLove from "./content/self-love.svelte";
  import Harmony from "./content/harmony.svelte";
  import Moving from "./content/moving.svelte";
  import Isolation from "./content/isolation.svelte";
  import Listening from "./content/listening.svelte";
  import Freedom from "./content/freedom.svelte";
  import Expression from "./content/expression.svelte";
  import Test from "./content/test.svelte";

  const routes = {
    "/Power": Power,
    "/Expression": Expression,
    "/Freedom": Freedom,
    "/Harmony": Harmony,
    "/Isolation": Isolation,
    "/Listening": Listening,
    "/Moving": Moving,
    "/Self-Love": SelfLove,
    "/WW": Test,
  };

  function handleClose() {
    dispatch("close", {});
  }
</script>

{#if shown}
  <div transition:fade={{ duration: 250 }}>
    <div transition:fly={{ y: 200, duration: 250 }} class="modal">
      <svg
        on:click={handleClose}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
      <Router {routes} />
    </div>
  </div>
{/if}

<style>
  .modal {
    width: 85%;
    height: auto;
    max-height: 80%;
    overflow-y: scroll;
    position: absolute;
    margin: 5%;
    background-color: #1c8a93;
    border: 10px solid #b2dee5;
    padding: 16px;
  }

  .modal::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }

  .modal::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
  }

  .modal::-webkit-scrollbar-thumb {
    background-color: #1c8a93;
  }

  div {
    z-index: 1000;
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  svg {
    width: 24px;
    height: 24px;
    padding-bottom: 16px;
  }
</style>
